const defaultDescription =
  "Cognitive scientist studying human attention, decision-making, and how AI and other new technologies affect performance on demanding tasks."

const defaultImageAlt =
  "Cary Stothart with the words I study how people think and decide when the stakes are high"

const pageSeoByPath = {
  "/": {
    title: "Cary Stothart, Ph.D.",
    description: defaultDescription,
    imageAlt: defaultImageAlt,
  },
  "/software": {
    title: "Software",
    description:
      "Software projects by Cary Stothart, including research tasks, data tools, and web apps.",
  },
  "/publications": {
    title: "Publications",
    description:
      "Research publications and reports by Cary Stothart on attention, decision-making, human factors, active inference, and applied cognitive science.",
  },
  "/contact": {
    title: "Contact",
    description:
      "Contact Cary Stothart about cognitive science, human performance, decision-making, research, and software projects.",
  },
}

const normalizePathname = pathname => {
  const cleanPath = (pathname || "/").split("?")[0].split("#")[0]
  const withoutTrailingSlash = cleanPath.replace(/\/+$/, "")
  return withoutTrailingSlash || "/"
}

export const getPageSeo = ({ pathname, pageContext } = {}) => {
  if (pageContext?.seo) {
    return pageContext.seo
  }

  return pageSeoByPath[normalizePathname(pathname)] || {}
}

export const getFallbackPageTitle = pathname => {
  const pageTitle = normalizePathname(pathname).match(/[A-z]+/g)?.[0]

  if (!pageTitle) {
    return undefined
  }

  return pageTitle[0].toUpperCase() + pageTitle.substring(1)
}
